/** 自动提现待处理 */
<template>
  <div class="home protocol-home">
    <Layout
      type="HOME"
      pageTitle="自动提现待处理列表"
      titleSrc="/menu/homeIcon_black.png"
    >
      <BasicLayout
        title="自动提现待处理列表"
        class="bonus-code-layout"
      >
        <div class="margin-20 display-flex">
          <!-- <el-input
            v-model="searchEmail"
            placeholder="输入要搜索的账号"
            style="max-width: 200px"
          ></el-input> -->
          <!-- <div
            class="button"
            @click="search"
          >搜索</div> -->
        </div>
        <div class="margin-20 display-flex">
          <el-table
            v-if="orderList && orderList.length"
            :data="orderList"
            style="width: 100%"
          >
            <el-table-column
              prop="ZFBName"
              label="支付宝姓名"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ZFBAccount"
              label="支付宝账号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="IDCard"
              label="证件号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="tel"
              label="手机号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="realMoney"
              label="需支付金额"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="email"
              label="邮箱"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="timestamp"
              label="发起时间"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="exchangeMoney"
              label="兑换京东卡数额"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="链上转账查询"
              align="center"
            >
              <template slot-scope="scope">
                <a
                  target="_blank"
                  :href='"https://console.bonuscloud.work/api/withdrawal/getBuybackStatus?transId=" + scope.row.transactionId'
                >
                  转账前确认
                </a>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="withStatus[scope.$index]"
                  class=""
                  @change="changeStatus(scope.row, scope.$index)"
                >
                  <el-option
                    default
                    v-for="item in withType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <!-- 状态 -->
            <el-table-column
              label="状态"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.status === 0">申请中</div>
                <div v-if="scope.row.status === 1">转账完成</div>
                <div v-if="scope.row.status === 2">账号错误</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="block display-flex-center">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="deviceSize"
            layout="total, prev, pager, next"
            :total="total">
            </el-pagination>
        </div>
      </BasicLayout>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { log } from "util";
import { Message } from "element-ui";
import Layout from "@/components/CRM/Layout.vue";
import BasicLayout from "@/components/Common/BasicLayout.vue";

export default {
  name: "home",
  data() {
    return {
      orderList: [],
      total: 0, //总数
      pageSize: 1,
      currentPage: 1,
      deviceSize: 20,
      withType: [
        {
          value: 0,
          label: "申请中",
        },
        {
          value: 1,
          label: "转账完成",
        },
        {
          value: 2,
          label: "账号错误",
        },
      ],
      withStatus: [],
    };
  },
  computed: mapState({}),
  components: {
    Layout,
    BasicLayout,
  },
  methods: {
    ...mapActions(["getAutoWithList", "setAutoWithStatus"]),
    changeStatus(value, index) {
      console.log(value, index);
      let status = this.withStatus[index];
      let id = value.id;

      this.setAutoWithStatus({ id, status }).then(() => {
        this.getAutoWithList({}).then((res) => {
          if (res.code == 200) {
            this.orderList = res.data;
          }
        });
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      this.getData({ page: val });
    },
    getData(data) {
      this.getAutoWithList(data).then((res) => {
        console.log(res);
        // res = {"code":200,"data":[{"id":9,"userId":"839be7a0cd5f11e8a0fc6b03f7abdc77","RMBPrice":0.0029,"exchangeMoney":200,"realMoney":190,"timestamp":"2020-11-18 11:11","transactionId":"a7d49197-c53a-403f-be68-5adeb22726d5","ZFBAccount":"13650566819","ZFBName":"陈瑶","discount":0.95,"exchangeBXC":68966,"status":0,"transferTimestamp":null,"email":"chenyaoswu@126.com"},{"id":10,"userId":"12b5fbc0e57911e8acc6fb0966c49a45","RMBPrice":0.0029,"exchangeMoney":200,"realMoney":190,"timestamp":"2020-11-18 12:11","transactionId":"5632105b-18b0-4e89-a38b-04788a47547c","ZFBAccount":"18095067827","ZFBName":"练郑宇","discount":0.95,"exchangeBXC":68966,"status":0,"transferTimestamp":null,"email":"1247254041@qq.com"},{"id":11,"userId":"839be7a0cd5f11e8a0fc6b03f7abdc77","RMBPrice":0.0029,"exchangeMoney":200,"realMoney":190,"timestamp":"2020-11-18 11:11","transactionId":"7fa2c839-8598-4983-9445-370538290620","ZFBAccount":"13650566819","ZFBName":"陈瑶","discount":0.95,"exchangeBXC":68966,"status":0,"transferTimestamp":null,"email":"chenyaoswu@126.com"}]};
        if (res.code == 200) {
          this.orderList = res.data;
          this.total = Number(res.total);
        }
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style  lang="stylus">
.node-dial-content {
  width: 80%;
}

.crm-node-content {
  padding-top: 80px;
  height: auto;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  text-align: left;
}

.label-button {
  max-width: 100%;
}
</style>
